import axios from 'axios';

const API_URL = `${process.env.VUE_APP_HOST}/api/survey`;
const API_RESPONSE_URL = `${process.env.VUE_APP_HOST}/api/surveyresponse`;

let access_token = "";

let auth = localStorage.getItem('session-authorization');

if (!auth) {
  access_token = process.env.VUE_APP_TOKEN;
  if (!access_token) {
    console.log(window.location.hash)
    var queries = window.location.hash.split("access_token=")
    if (queries.length > 1) {
      access_token = queries[1].split("&")[0]
      if (access_token) {
        let auth = "{\"access_token\":\"" + access_token + "\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
        localStorage.setItem('session-authorization', auth);
      }
    }
  }
}
else {
  access_token = JSON.parse(auth).access_token;
}

let headers = {
  headers: {
    'Authorization': `Bearer ${access_token}`,
    'Content-Type': 'application/json'
  }
};


export const surveyApi = {
  
  getAll: async (userRole, userDepartment, userSchool) => {
    try {
      const response = await axios.get(API_URL, headers);
      const surveys = response.data;
      
      // Filter surveys based on user role and permissions
      return surveys.map(survey => ({
        ...survey,
        publishedStatus: survey.status === 'Published' ? getPublishedStatus(survey) : null
      }));
    } catch (error) {
      console.error('Error fetching surveys:', error);
      throw error;
    }
  },
  getDeptAll: async (userRole, userDepartment, userSchool) => {
    try {
      const response = await axios.get(API_URL+'/dept', headers);
      const surveys = response.data;
      
      // Filter surveys based on user role and permissions
      return surveys.map(survey => ({
        ...survey,
        publishedStatus: survey.status === 'Published' ? getPublishedStatus(survey) : null
      }));
    } catch (error) {
      console.error('Error fetching surveys:', error);
      throw error;
    }
  },
  
   
  getAllWithStat: async (userRole, userDepartment, userSchool) => {
    try {
      const response = await axios.get(API_URL+'/stat', headers);
      const surveys = response.data;
      
      // Filter surveys based on user role and permissions
      return surveys.map(survey => ({
        ...survey,
        publishedStatus: survey.status === 'Published' ? getPublishedStatus(survey) : null
      }));
    } catch (error) {
      console.error('Error fetching surveys:', error);
      throw error;
    }
  },

  getUniversitySurveyResults: async (surveyId, level) => {
    // Simulate API call delay
    const response = await axios.get(`${API_RESPONSE_URL}/${surveyId}/summary?level=`+level, headers);

    const surveyData = response.data
    // Return mock data for the specified survey
    if (!surveyData) {
      throw new Error('Survey not found');
    }
    return surveyData;
  },
  create: async (survey) => {
    try {
      const response = await axios.post(API_URL, survey, headers);
      return response.data;
    } catch (error) {
      console.error('Error creating survey:', error);
      throw error;
    }
  },

  update: async (id, survey) => {
    try {
      const response = await axios.put(`${API_URL}/${id}`, survey, headers);
      return response.data;
    } catch (error) {
      console.error('Error updating survey:', error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      await axios.delete(`${API_URL}/${id}`, headers);
    } catch (error) {
      console.error('Error deleting survey:', error);
      throw error;
    }
  },

  publish: async (id) => {
    try {
      console.log(`${API_URL}/${id}/publish`)
      const response = await axios.put(`${API_URL}/${id}/publish`, null, headers);
      return response.data;
    } catch (error) {
      console.error('Error publishing survey:', error);
      throw error;
    }
  },

  revoke: async (id) => {
    try {
      const response = await axios.put(`${API_URL}/${id}/revoke`, null, headers);
      return response.data;
    } catch (error) {
      console.error('Error revoking survey:', error);
      throw error;
    }
  },

  updateModuleDates: async (surveyId, moduleDates) => {
    try {
      let _payload = moduleDates
      console.log(_payload)
      const response = await axios.put(`${API_URL}/${surveyId}/module-dates`, _payload, headers);
      return response.data;
    } catch (error) {
      console.error('Error updating module dates:', error);
      throw error;
    }
  },
  getModuleDates: async (surveyId) => {
    try {
      const response = await axios.get(`${API_URL}/${surveyId}/module-dates`, headers);
      return response.data;
    } catch (error) {
      console.error('Error fetching module dates:', error);
      throw error;
    }
  },
  getSurveyOverview: async () => {
    const response = await axios.get(`${API_URL}/overview`, headers);
    return response.data;
  },
  getStudentDataForSurvey: async (surveyId, studentId) => {
    try {
      const response = await axios.get(`${API_URL}/${surveyId}/student/${studentId}`, headers);
      return response.data;
    } catch (error) {
      console.error('Error fetching student data for survey:', error);
      throw error;
    }
  },
  getStudentData: async (studentId) => {
    try {
      const response = await axios.get(`${API_URL}/surveydata/${studentId}`, headers);
      return response.data;
    } catch (error) {
      console.error('Error fetching student data for survey:', error);
      throw error;
    }
  },
  getAvailableSurveysForStudent: async (studentId) => {
    try {
      const response = await axios.get(`${API_URL}/${studentId}/available-surveys`, headers);
      return response.data;
    } catch (error) {
      console.error('Error fetching available surveys for student:', error);
      throw error;
    }
  },
  saveSurvey: async (surveyId, surveyData) => {
    try {
      const response = await axios.post(`${API_RESPONSE_URL}/${surveyId}/save`, surveyData, headers); //API_URL used instead of API_BASE_URL as per original code
      return response.data;
    } catch (error) {
      console.error('Error saving survey:', error);
      throw error;
    }
  },
  submitSurvey: async (surveyId, surveyData) => {
    try {
      const response = await axios.post(`${API_RESPONSE_URL}/${surveyId}/submit`, surveyData, headers); //API_URL used instead of API_BASE_URL as per original code
      return response.data;
    } catch (error) {
      console.error('Error saving survey:', error);
      throw error;
    }
  },
  getSurveyResponse: async (surveyId, studentId) => {
    try {
      const response = await fetch(`${API_RESPONSE_URL}/${surveyId}/${studentId}`, headers);
      if (!response.ok) {
        throw new Error('Failed to fetch survey response');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      return null;
      //console.error('Error fetching survey response:', error);
      //throw error;
    }
  },

  getSurveyResponseComments: async (surveyId, moduleCode) => {
    try {
      const response = await fetch(`${API_RESPONSE_URL}/${surveyId}/OptionalComments?moduleCode=${moduleCode}`, headers);
      if (!response.ok) {
        throw new Error('Failed to fetch survey response');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      return null;
      //console.error('Error fetching survey response:', error);
      //throw error;
    }
  },


  
  getSurveyResponseCommentsByModuleList: async (surveyId, payload) => {
    try {
      const response = await axios.post(`${API_RESPONSE_URL}/${surveyId}/OptionalComments`, payload, headers);
      return response.data;
    } catch (error) {
      return null;
      //console.error('Error fetching survey response:', error);
      //throw error;
    }
  },


  downloadSurveyResponse: async (surveyId, isAdmin) => {
    try {
      let _url = isAdmin ? `${API_RESPONSE_URL}/${surveyId}/download?isAdmin=true` : `${API_RESPONSE_URL}/${surveyId}/download`;
      const response = await axios.get(_url, {
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${access_token}`
        }
      });
      return response.data;
    } catch (error) {
      return null;
      //console.error('Error fetching survey response:', error);
      //throw error;
    }
  },


  sendSingleEmail: async (surveyId, studentId) => {
    try {
      const response = await axios.post(`${API_URL}/${surveyId}/${studentId}/sendemail`, null, headers);
      if (!response.ok) {
        throw new Error('Failed to fetch survey response');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      return null;
      //console.error('Error fetching survey response:', error);
      //throw error;
    }
  },
  getSurveyResults: async (surveyId, date) => {
    let url = `${API_RESPONSE_URL}/${surveyId}/DeptReport`;
    if (date)
      url += `?date=${date}`;
    const response = await axios.get(url, headers);
    return response.data;
  },
  getInstitutionSettings: async () => {
    try {
      const response = await axios.get(`${API_URL}/InstitutionSettings`, headers);
      return response.data;
    } catch (error) {
      return null;
    }
  },
  putInstitutionSettings: async (payload) => {
    try {
      let id = payload.id;
      const response = await axios.put(`${API_URL}/InstitutionSettings/${id}`, JSON.stringify(payload), headers);
      return response.data;
    } catch (error) {
      return null;
    }
  },
};

// Helper function to get the current status of a published survey
const getPublishedStatus = (survey) => {
  const now = new Date();
  if (now < new Date(survey.startDate)) return 'Pending';
  if (now >= new Date(survey.startDate) && now <= new Date(survey.endDate)) return 'Active';
  return 'Completed';
};


